"use strict";
var $ = require("jquery");
var ajaxUtils_1 = require("../../app/utils/ajaxUtils");
var PostUtils = (function () {
    function PostUtils() {
    }
    PostUtils.vote = function (btn, postId, vote) {
        var $btn = $(btn);
        if ($btn.attr("disabled"))
            return;
        var toggleClass = "toggle", $box = $btn.parents(".post-rating-box"), $rating = $box.find(".post-rating-count"), voteId = $rating.attr("data-vote-id");
        $btn.attr("disabled", "disabled");
        ajaxUtils_1.AjaxUtils.post("post/vote", {
            voteId: voteId,
            targetId: postId,
            isLiked: $btn.hasClass(toggleClass) ? null : vote === 1
        }).done(function (result) {
            if (result.isSuccessful) {
                $rating.html(result.data.rating);
                $rating.attr("data-vote-id", result.data.voteId);
                if ($btn.hasClass(toggleClass)) {
                    $btn.removeClass(toggleClass);
                }
                else {
                    $box.find(".like, .dislike").removeClass(toggleClass);
                    $btn.addClass(toggleClass);
                }
            }
            else {
                alert(result.messages[0]);
            }
        }).always(function () {
            $btn.removeAttr("disabled");
        });
    };
    PostUtils.toggleFavorite = function (btn, postId) {
        var $btn = $(btn);
        if ($btn.attr("disabled"))
            return;
        $btn.attr("disabled", "disabled");
        var toggleClass = "toggle", isActive = $btn.hasClass(toggleClass);
        if (!isActive) {
            $btn.addClass("animate");
            setTimeout(function () {
                $btn.removeClass("animate");
            }, 500);
        }
        var ajaxSetFavor = function () {
            ajaxUtils_1.AjaxUtils.post("post/toggleFavorite", {
                postId: postId,
                toggle: !isActive
            }).done(function (result) {
                if (result.isSuccessful) {
                    if (isActive) {
                        $btn.removeClass(toggleClass);
                    }
                    else {
                        $btn.addClass(toggleClass);
                    }
                }
                else if (result.isWarning) {
                    toastr.warning(result.messages[0]);
                }
                else {
                    alert(result.messages[0]);
                }
            }).always(function () {
                $btn.removeAttr("disabled");
            });
        };
        if (isActive) {
            app.f7.modal({
                title: "Вы уверены?",
                text: "\u0412\u044B \u0442\u043E\u0447\u043D\u043E \u0445\u043E\u0442\u0438\u0442\u0435 \u0443\u0434\u0430\u043B\u0438\u0442\u044C \u043F\u043E\u0441\u0442 \u0438\u0437 \u0441\u043E\u0445\u0440\u0430\u043D\u0435\u043D\u043D\u044B\u0445?",
                buttons: [
                    {
                        text: "Отмена",
                        onClick: function () { $btn.removeAttr("disabled"); }
                    },
                    {
                        text: "Удалить",
                        onClick: function () { ajaxSetFavor(); }
                    }
                ]
            });
        }
        else {
            ajaxSetFavor();
        }
    };
    PostUtils.toggleUserPinned = function (btn, postId) {
        var $btn = $(btn);
        var postPinnedClass = 'post-pinned', toogleClass = 'toogle', isActive = $btn.hasClass(toogleClass);
        if ($btn.attr("disabled"))
            return;
        $btn.attr("disabled", "disabled");
        ajaxUtils_1.AjaxUtils.post("post/toggleUserPin", {
            objectId: postId,
            enabled: !isActive
        }).done(function (result) {
            if (result.isSuccessful) {
                if (!isActive) {
                    $("." + postPinnedClass + "." + toogleClass).removeClass(toogleClass);
                }
                $btn.addClass(toogleClass);
                alert(result.messages[0]);
                setTimeout(function () {
                    window.location.reload();
                }, 1000);
            }
            else if (result.isWarning) {
                alert(result.messages[0]);
            }
            else {
                alert(result.messages[0]);
            }
        }).always(function () {
            $btn.removeAttr("disabled");
        });
    };
    return PostUtils;
}());
if (!window["AppUtils"])
    window["AppUtils"] = {};
window["AppUtils"].Post = PostUtils;
Object.defineProperty(exports, "__esModule", { value: true });
exports.default = PostUtils;
//# sourceMappingURL=postUtils.js.map